module.exports = __webpack_public_path__ + "img/Bitmap.36e4b02.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Bitmap.png
// module id = ./assets/images/Bitmap.png
// module chunks = 2